import { HOME_PAGE_ROUTE } from '@constants/routes';
import logoFull from '@images/logo-blue.svg';
import logoMark from '@images/logo-mark.svg';
import clsx from 'clsx';
import type React from 'react';
import { Link } from 'react-router';

interface SidebarLogoProps {
  expanded: boolean;
}

export const SidebarLogo: React.FC<SidebarLogoProps> = ({ expanded }) => {
  return (
    <Link
      to={HOME_PAGE_ROUTE}
      className={clsx(
        'flex items-center min-w-0',
        expanded ? 'justify-start' : 'justify-center',
      )}>
      <img
        src={expanded ? logoFull : logoMark}
        alt='Conversed'
        className={expanded ? 'h-6 w-auto' : 'h-6 w-6'}
      />
    </Link>
  );
};

export default SidebarLogo;
